import { gql } from "@apollo/client";

export const GET_UNIVERSITY_TEST_RESULTS = gql`
  query getUniversityTestResults(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeEducationUniversityTestResultsInput!
  ) {
    universityTestResults(first: $first, last: $last, before: $before, after: $after, input: $input) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        testId
        levelCode
        testDate
        score
        maxScore
        status
        attemptNumber
        isRetake
        isPassed
        isFailed
        testDefinition {
          testId
          levelCode
          description
          maxScore
        }
        student {
          id
          pgaId
          firstName
          lastName
          displayName
          profilePhoto
        }
      }
    }
  }
`;

export const GET_UNIVERSITY_STUDENTS_WITH_TEST_SCORES = gql`
  query getUniversityStudentsWithTestScores(
    $first: Int
    $last: Int
    $before: String
    $after: String
    $input: BackofficeUniversityStudentsInput
    $levelCodes: [String!]
    $testStatus: String
    $testDateRange: DateRangeInput
  ) {
    universityStudents(first: $first, last: $last, before: $before, after: $after, input: $input) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        firstName
        lastName
        displayName
        profilePhoto
        pgaId
        educationLatestPgmProgram {
          level
          levelCode
          curriculumVersion
          testsPassedCount
          testsFailedCount
          totalTestsCount
          testsPassedByLevel
          testsFailedByLevel
          testHistory(levelCodes: $levelCodes, status: $testStatus, testDateRange: $testDateRange) {
            testId
            levelCode
            testDate
            score
            maxScore
            status
            attemptNumber
            isRetake
            isPassed
            isFailed
            completionStatus
            testDefinition {
              testId
              levelCode
              description
              maxScore
              oldTestId
            }
          }
        }
        educationTestHistory(levelCodes: $levelCodes, status: $testStatus, testDateRange: $testDateRange) {
          testId
          levelCode
          testDate
          score
          maxScore
          status
          attemptNumber
          isRetake
          isPassed
          isFailed
          completionStatus
          testDefinition {
            testId
            levelCode
            description
            maxScore
            oldTestId
          }
        }
      }
    }
  }
`;
